import styled from '@themes/theme'

export const TutorialVideoWrap = styled.div`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-45%);
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  .video-wrap {
    position: relative;
    width: calc(100vw - 28px);
    height: calc(61vw - 28px);
    padding: 9px;
    .frame-img {
      z-index: -1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  .event-guide-btn {
    margin-top: 40px;
    padding: 0 30px;
    border-radius: 0;
    .event-guide-banner {
      width: 100%;
      height: auto;
    }
  }

  &.pc-tutorial-video-wrap {
    width: 414px;
    .video-wrap {
      width: 100%;
      height: 230px;
    }
  }

`
